export default __webpack_public_path__ + "static/top-pic-03-0f9524ef352e74976c027bdfcd194460.png";